export const formatArrayField = (array, key, separator = ', ') => {
  if (!array || array.length === 0) return '-';

  return (
    array
      .map((item) => {
        if (typeof item === 'string') return item;

        if (key && key.includes('.')) {
          return key.split('.').reduce((obj, k) => obj?.[k], item);
        }

        return item[key];
      })
      .filter(Boolean)
      .join(`${separator}`) || '-'
  );
};

export const getFieldValue = (value) => {
  if (value === null || value === undefined || value === '') return '-';
  return value;
};

/**
 * Format approval/registration number by removing .00 decimal places
 * @param {string|number} approvalNumber - The approval number to format
 * @returns {string} Formatted approval number without .00 decimals, or '-' if empty
 */
export const formatApprovalNumber = (approvalNumber) => {
  if (approvalNumber === null || approvalNumber === undefined || approvalNumber === '') return '-';

  let formattedNumber = approvalNumber;
  if (typeof approvalNumber === 'string') {
    // Remove .00 at the end if present
    formattedNumber = approvalNumber.replace(/\.00$/, '');
  } else if (typeof approvalNumber === 'number') {
    // Convert number to string and remove .00 if present
    formattedNumber = approvalNumber.toString().replace(/\.00$/, '');
  }

  return formattedNumber;
};
